import React from "react";
import "./footer.css";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const Footer = ({ res }) => {
  return (
    <section className="footer mt-10">
      <div className="box-container">
        <Container>
          <Row>
            <Col lg="12" md="12" sm="12" xs="12">
              <div className="box text-dark">
                <h3 className="mb-5">
                  <Link to="#">{res?.FIRMA}</Link>
                </h3>
                <div className="share">
                  {res.FACEBOOK && (
                    <a
                      target="_blank"
                      href={res?.FACEBOOK}
                      className="fab fa-facebook-f"
                      // rel="noopener noreferrer"
                    >
                      {" "}
                    </a>
                  )}
                  {res.TWITTER && (
                    <a
                      target="_blank"
                      href={res?.TWITTER}
                      className="fab fa-twitter"
                    >
                      {" "}
                    </a>
                  )}
                  {res.INSTAGRAM && (
                    <a
                      target="_blank"
                      href={res?.INSTAGRAM}
                      className="fab fa-instagram"
                    >
                      {" "}
                    </a>
                  )}
                  {res.LINKEDLN && (
                    <a
                      target="_blank"
                      href={res?.LINKEDLN}
                      className="fab fa-linkedin"
                    >
                      {" "}
                    </a>
                  )}
                </div>
              </div>
            </Col>
            <Col lg="12" md="12" sm="12" xs="12">
              <div className="box mt-4">
                {res.TELEFON && (
                  <a href={`tel:${res.TELEFON}`} className="links text-dark">
                    {" "}
                    <i className="fas fa-phone "></i>
                    {res.TELEFON}
                  </a>
                )}
                {res.MAIL && (
                  <a href={`mailto:${res.MAIL}`} className="links text-dark">
                    {" "}
                    <i className="fas fa-envelope"></i>
                    {res.MAIL}
                  </a>
                )}
                {res.ADRES && (
                  <a to="/contact" className="links text-dark">
                    {" "}
                    <i className="fas fa-map-marker-alt"></i>
                    {res.ADRES}
                  </a>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="stick">
        <a href="https://www.mikom.com.tr/" className="mobrespos">
          © 2024 | Tüm Hakları Saklıdır. MobresPos Yazılım
        </a>
      </div>
    </section>
  );
};

export default Footer;
